import React from 'react'
import ActivitiesIndex from '../features/activities'
function Activities() {
  return (
    <ActivitiesIndex />
  )
}

export default Activities